import { useTranslation } from "react-i18next"
import CommonUtil from "../../../utils/CommonUtil"
import { useEffect } from "react"

const ShootUnConnect = props => {
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('shoot_item1'))
        }
    }

    useEffect(() => {
        postTitle()
    }, [])

    return <div className="App">
        <div className="bind-device-faq">
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#333333', marginTop: 15, lineHeight: '22px', fontWeight: '500' }}>{t('shoot_unconnect_step1')}</span>
            </div>
            <div className="bind-device-faq-marginH20">
                <img src={`${CommonUtil.getSourceDomain()}camera_started.png`} alt="" style={{ width: '100%', marginLeft: 20, marginTop: 15 }} />
            </div>
            <div style={{ height: 25 }} />
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#333333', marginTop: 15, lineHeight: '22px', fontWeight: '500' }}>{t('shoot_unconnect_step2')}</span>
                <span style={{ fontSize: 14, color: '#333333', lineHeight: '22px', fontWeight: '500' }}>{t('shoot_unconnect_step3')}</span>
                <span style={{ fontSize: 14, color: '#333333', lineHeight: '22px', fontWeight: '500' }}>{t('shoot_unconnect_step4')}</span>
            </div>
            {/* <div className="bind-device-faq-marginH20">
                <img src={`${CommonUtil.getSourceDomain()}bluetooth_enabled.png`} alt="" style={{ width: '100%', marginLeft: 20, marginTop: 15 }} />
            </div> */}
            {/* <div style={{ height: 25 }} /> */}
            {/* <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#333333', marginTop: 15, lineHeight: '22px', fontWeight: '500' }}>{t('shoot_unconnect_step4')}</span>
            </div> */}
            {/* <div className="bind-device-faq-marginH20">
                <img src={`${CommonUtil.getSourceDomain()}wifi_setting.png`} alt="" style={{ width: '100%', marginLeft: 20, marginTop: 15 }} />
            </div>
            <div style={{ height: 25 }} /> */}
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#333333', marginTop: 30, lineHeight: '22px', fontWeight: '500' }}>{t('shoot_unconnect_step5')}</span>
            </div>
            {/* <div className="bind-device-faq-marginH20">
                <img src={`${CommonUtil.getSourceDomain()}local_net_permission.png`} alt="" style={{ width: '100%', marginLeft: 20, marginTop: 15 }} />
            </div> */}
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#333333', marginTop: 15, lineHeight: '22px', fontWeight: '500' }}>{t('shoot_unconnect_step6')}</span>
            </div>
            <div style={{ height: 20 }} />
        </div>
    </div>
}

export default ShootUnConnect